import React, {Component} from 'react'
import {Table, message, Upload} from 'antd';
import {
    baseUrl, reqGetDeclares,
} from '../../api'
import './index2.less';

export default class OrderDeclare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            declareList: [],
        }
    }

    componentDidMount() {
        const orderId = this.props.orderId || this.props.location.state.orderId;
        this.getProducts({id: orderId});
        this.setState({orderId});
    }

    getProducts = async (values = {}, pageNum = 1, pageSize = 10) => {
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqGetDeclares(values);
        if (result.code == '200') {
            this.setState({
                pageNum: pageNum,
                pageSize: pageSize,
                total: result.data.total,
                declareList: result.data.rows,
            })
        } else {
            message.error(result.message)
        }
    };

    render() {
        const {orderId, pageNum, pageSize, total, declareList} = this.state;
        const columns = [
            {
                title: '序号',
                dataIndex: 'index',
                render: (text, record, index) => (
                    <span>{index + 1 + (pageNum - 1) * pageSize}</span>
                )
            }, {
                title: '集装箱号',
                dataIndex: 'boxNo',
            }, {
                title: '报关代码',
                dataIndex: 'declareCode',
            }, {
                title: '报关单号',
                dataIndex: 'declareNo',
            }, {
                title: '货值',
                dataIndex: 'boxValue',
            }, {
                title: '币制',
                dataIndex: 'currency',
            }, {
                title: '票数',
                dataIndex: 'nums',
            }, {
                title: '报关单',
                dataIndex: 'fileLocation',
                render: (text, record) => {
                    const fileList = [];
                    if (record.fileId && record.fileId != null) {
                        fileList.push({
                            uid: record.fileId,
                            name: record.fileName,
                            url: baseUrl + '/' + text,
                            objectId: record.id,
                            status: 'done',
                        });
                    }
                    return <Upload defaultFileList={fileList}
                                   capture="camera" disabled={true}></Upload>
                }
            },
        ];
        return (
            <div className='order-space'>
                <Table className='common-box-margin-top'
                       columns={columns}
                       bordered
                       dataSource={declareList}
                       rowKey='id'
                       pagination={{
                           current: pageNum,
                           total: total,
                           showQuickJumper: true,
                           onChange: (pageNum) => this.getProducts({id: orderId}, pageNum)
                       }}
                       size="middle"/>
            </div>
        )
    }
}